import { api } from "_shared/_stores/api";
import IndividualSchema, { IndividualJSON } from "marketplace/individuals/_schemas/individual-schema";
import z from "zod";

export const individualsApi = api.injectEndpoints({
  endpoints: (build) => ({
    // #region Get
    getIndividualById: build.query<IndividualJSON, { individualId: string }>({
      query: ({ individualId }) => `marketplace/individuals/${individualId}`,
      rawResponseSchema: IndividualSchema.IndividualJSONZ,
      providesTags: (result) =>
        result ? [{ type: "Individual" as const, id: result.id }] : [{ type: "Individual" as const, id: "LIST" }],
    }),
    getIndividualsByUserIds: build.query<IndividualJSON[], { userIds: Set<string> }>({
      query: ({ userIds }) => ({
        url: "marketplace/individuals-by-userids",
        method: "POST",
        body: Array.from(userIds),
      }),
      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        const normalized = [...new Set(...queryArgs.userIds)].sort((a, b) => a.localeCompare(b));
        return `${endpointName}(${normalized.join(",")})`;
      },
      rawResponseSchema: z.array(IndividualSchema.IndividualJSONZ),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "Individual" as const, id: id })),
              { type: "Individual" as const, id: "LIST" },
            ]
          : [{ type: "Individual" as const, id: "LIST" }],
    }),
    // #endregion
  }),
});

export const { useGetIndividualByIdQuery, useGetIndividualsByUserIdsQuery } = individualsApi;
